export default "__VITE_ASSET__BrAA$f_O__"